import { StatusInfo } from "./statusinfo";
export class Timeline {
    effectiveDate: string = "";
    statusInfo: StatusInfo; 
  }
  